import React from 'react';
import PropTypes from 'prop-types';

import MailchimpIntegrationCard from './Mailchimp/MailchimpIntegrationCard';
import ShopifyIntegrationCard from './Shopify/ShopifyIntegrationCard';

const IntegrationCards = (
  {
    baseUrl,
    ecommerceIntegrationEnabled,
    mailchimpIntegrationEnabled,
  }) => (
    <div className="integrations__cards" data-automation-id="integrations-cards">
      <MailchimpIntegrationCard
        baseUrl={baseUrl}
        display-if={mailchimpIntegrationEnabled}
      />
      <ShopifyIntegrationCard
        baseUrl={baseUrl}
        display-if={ecommerceIntegrationEnabled}
      />
    </div>
);

IntegrationCards.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  ecommerceIntegrationEnabled: PropTypes.bool.isRequired,
  mailchimpIntegrationEnabled: PropTypes.bool.isRequired,
};

export default IntegrationCards;
